import ReactDOM from 'react-dom/client';

import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';

import '@spotify/confidence-dev-instrumentation/bootstrap';

import app from './App';
import './bootstrap';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element');
}
ReactDOM.createRoot(rootElement).render(app);
